import { Component, OnInit, Input, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $;

@Component({
  selector: 'ocr-text-config-box',
  templateUrl: './ocr-text-config-box.component.html',
  styleUrls: ['./ocr-text-config-box.component.css']
})
export class ocrTextConfigBoxComponent implements OnInit {

  constructor(private el: ElementRef,
    private box: SwMassageBoxService,) { }

  
  @Input() ids:any;

  @Input() title:any;

  @Input() elemId:any;

  @Input() index:any;

  @Input() index2:any;  //对于校验页面会用到

  @Input() dropdown: boolean = true;;

  @Input() configHeight: string = '150px';

   /**
   * type 类型
   * 值为1：代表 向下添加文字
   * 值为2：代表 文字纠正
   * 值为3：代表 向上添加文字
   * @ignore
   */
  @Input() type:number= 1

  @Input() upordowntype:number= 1


  /**
 *  选中的文字信息，如id，text==》文字纠正
 * @ignore
 */
@Input() selectedValue :any= {};  

inputText:string = ''
  /**
   * 搜索框的值
   */
  filter: any;

  /**
   * 选中数据
   */
  @Output() changeClick = new EventEmitter();
  @Output() closeSelect = new EventEmitter();
  ngOnInit() {
    if(this.type == 2||this.type==7){
      this.inputText = this.selectedValue.word
    }else {
      this.inputText = ''
    }
  }
  ngAfterViewInit(): void {
    //浏览器的宽度
    let windowWidth = $(window).width()
    //如果有搜索框则给焦点
    let postion = document.getElementById(this.elemId).getBoundingClientRect()
    
    let wids = 200
    this.el.nativeElement.style.position = 'fixed';
    this.el.nativeElement.style.zIndex = 9990;
    
    this.el.nativeElement.style.width = wids + 'px';

    let height = this.configHeight.split('px')[0]
    let clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    let heightAndTop = clientHeight + scrollTop

    let cha = 6

    if(windowWidth - postion.right <(wids-0+6)){
      this.el.nativeElement.style.left = postion.left - wids - 2 + 'px';
    }else {
      this.el.nativeElement.style.left = postion.right + cha + 'px';
    }

    if((heightAndTop-postion.top)<parseInt(height) ){ 
      this.el.nativeElement.style.top = postion.bottom - parseInt(height)+ 'px';
    }else {
      this.el.nativeElement.style.top = postion.top + 'px';
    }
  
    this.myModalBodyScroll()  //监听 myModalBody 盒子的滚动条事件
    this.myWrapContScroll()  //监听 myWrapCont 盒子的滚动条事件
  }

  ngOnDestroy(): void {
    this.myModalBodyRmScroll()  //移除 myModalBody 盒子的滚动条事件
    this.myWrapContRmScroll()  //移除 myWrapCont 盒子的滚动条事件
  }

  inputTextOnBlur($event) {
    
  }
  //文字纠正  type类型 ： delete删除、edit修改的保存、save确定（向下添加文字保存）、saveUp确定（向上添加文字保存）
  clickConfig(event,type){
    event.stopPropagation()
    //
    let params = {
      type:type,
      value:this.inputText,
      textType:this.selectedValue.type,
      index:this.index,
      index2:this.index2,
    }
    this.changeClick.emit(params);
    
  }
  stopPro(event) {
    event.stopPropagation()
  }

  close(){
    this.closeSelect.emit(false)
  }

  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    //鉴定全屏键盘事件 如果是回车触发
    if(this.mouseo)
        this.closeSelect.emit(false)
  } 

  // //屏幕缩放时
  // @HostListener('window:resize', ['$event']) resize(event) {
  //   /* //屏幕缩放时,下拉框消失,否则下拉框
  //   this.closeSelect.emit(false) */
  //   //屏幕缩放时,重新设置下拉框的位置及宽度
  //   let postion = this.elem.nativeElement.getBoundingClientRect()
  //   this.el.nativeElement.style.top = postion.bottom + 'px';
  //   this.el.nativeElement.style.left = postion.left + 'px';
  //   this.el.nativeElement.style.width = postion.width + 'px';
  // }

  mouseo:boolean = true;
  mouseoverEvent(){
    this.mouseo = false;
  }
  mouseoutEvent(){
    this.mouseo = true;
  }

  //监听 myWrapCont 盒子的滚动条事件,滚动就让日期控件消失
  myWrapContScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myWrapContRmScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myWrapContScroll)
    }
  }

  //监听 myModalBody 盒子的滚动条事件,滚动就让日期控件消失
  myModalBodyScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myModalBodyRmScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myModalBodyScroll)
    }
  }

 //监听查看示例事件
 @HostListener('document:click', ['$event'])
 public onClick(event) {
      event.stopPropagation()
      setTimeout(()=>{
        if(this.elemId){
          const clickInside = this.el.nativeElement.contains(event.target) 
          const clickInside2 = document.getElementById(this.elemId) ? document.getElementById(this.elemId).contains(event.target):false
          if(!(clickInside || clickInside2)) {
           this.closeSelect.emit(false)
          }
        }
       
      },20)
 }

  // //创建新标签
  // add(){
  //   this.addNewClick.emit(this.filter)
  //   this.closeSelect.emit(false)  //销毁组件
  // }

}
